import AxiosServices from './axios-service';
import { endpoints } from './api-end-points';

export class CommonService {

  get_record(body) {
    const res = AxiosServices.post(endpoints.common.get_record, body);
    return res;
  }

  get_installtions(body) {
    const res = AxiosServices.post(endpoints.common.get_installtions, body);
    return res;
  }

  visitor_pass_installations(body) {
    const res = AxiosServices.post(endpoints.common.visitor_pass_installations, body);
    return res;
  }

  get_group_types(body) {
    const res = AxiosServices.post(endpoints.common.get_group_types, body);
    return res;
  }

  get_integra_installtions(body) {
    const res = AxiosServices.post(endpoints.common.get_integra_installtions, body);
    return res;
  }

  get_integra_ins_id(body) {
    const res = AxiosServices.post(endpoints.common.get_integra_ins_id, body);
    return res;
  }

  get_ticket_ins_id(body) {
    const res = AxiosServices.post(endpoints.common.get_ticket_ins_id, body);
    return res;
  }

  get_integra_groups_by_ins_id(body) {
    const res = AxiosServices.post(endpoints.common.get_integra_groups_by_ins_id, body);
    return res;
  }

  get_last_ids(body) {
    const res = AxiosServices.post(endpoints.common.get_last_ids, body);
    return res;
  }

  get_groups_by_ins_id(body) {
    const res = AxiosServices.post(endpoints.common.get_groups_by_ins_id, body);
    return res;
  }

  get_external_permits_grpt_id_by_ins_id(body) {
    const res = AxiosServices.post(endpoints.common.get_external_permits_grpt_id_by_ins_id, body);
    return res;
  }

  insert_to_db(body) {
    const res = AxiosServices.post(endpoints.common.insert_to_db, body);
    return res;
  }

  insert_to_integra(body) {
    const res = AxiosServices.post(endpoints.common.insert_to_integra, body);
    return res;
  }

  insert_to_ticket(body) {
    const res = AxiosServices.post(endpoints.common.insert_to_ticket, body);
    return res;
  }

  get_button_ins(body) {
    const res = AxiosServices.post(endpoints.common.get_button_ins, body);
    return res;
  }

  get_button_groups(body) {
    const res = AxiosServices.post(endpoints.common.get_button_groups, body);
    return res;
  }

  button_to_wheel(body) {
    const res = AxiosServices.post(endpoints.common.button_to_wheel, body);
    return res;
  }

  get_integra_group_by_dbPIC_grp_id(body) {
    const res = AxiosServices.post(endpoints.common.get_integra_group_by_dbPIC_grp_id, body);
    return res;
  }

  get_monthly_permits_groups(body) {
    const res = AxiosServices.post(endpoints.common.get_monthly_permits_groups, body);
    return res;
  }

  get_monthly_permit(body) {
    const res = AxiosServices.post(endpoints.common.get_monthly_permit, body);
    return res;
  }

  update_monthly_permit(body) {
    const res = AxiosServices.post(endpoints.common.update_monthly_permit, body);
    return res;
  }

  get_monthly_permit_by_grp_id(body) {
    const res = AxiosServices.post(endpoints.common.get_monthly_permit_by_grp_id, body);
    return res;
  }

  get_grpt_by_ins_id(body) {
    const res = AxiosServices.post(endpoints.common.get_grpt_by_ins_id, body);
    return res;
  }

  disable_zone(body) {
    const res = AxiosServices.post(endpoints.common.disable_zone, body);
    return res;
  }

  get_rates_by_grp_id(body) {
    const res = AxiosServices.post(endpoints.common.get_rates_by_grp_id, body);
    return res;
  }

  get_disabled_groups_by_ins_id(body) {
    const res = AxiosServices.post(endpoints.common.get_disabled_groups_by_ins_id, body);
    return res;
  }

  enable_zone(body) {
    const res = AxiosServices.post(endpoints.common.enable_zone, body);
    return res;
  }

  add_door_code(body) {
    const res = AxiosServices.post(endpoints.common.add_door_code, body);
    return res;
  }

  get_tariffs_by_grp_id(body) {
    const res = AxiosServices.post(endpoints.common.get_tariffs_by_grp_id, body);
    return res;
  }

  get_parameters(body) {
    const res = AxiosServices.post(endpoints.common.get_parameters, body);
    return res;
  }

  recycle(body) {
    const res = AxiosServices.post(endpoints.common.recycle, body);
    return res;
  }

  get_last_dat_dah_id(body) {
    const res = AxiosServices.post(endpoints.common.get_last_dat_dah_id, body);
    return res;
  }

  get_tar_id_by_grpt(body) {
    const res = AxiosServices.post(endpoints.common.get_tar_id_by_grpt, body);
    return res;
  }

  insert_to_visitorpass(body) {
    const res = AxiosServices.post(endpoints.common.insert_to_visitorpass, body);
    return res;
  }

  async cloneInstallationData(body) {
    const [
      externalProvidersApiMethods,
      externalProvidersIns,
      dbpicInstallation,
      integraInstallation,
      finanDistOperatorInstallation,
      finanDistOperatorParsOpeType,
      installationsFinanParsOpeType,
      installationsLastIds
    ] = await Promise.all([
      AxiosServices.post(endpoints.common.get_external_providers_api_mehtods_by_ins_id, body),
      AxiosServices.post(endpoints.common.get_external_providers_ins_by_ins_id, body),
      AxiosServices.post(endpoints.common.get_dbpic_installation_by_ins_id, body),
      AxiosServices.post(endpoints.common.get_integra_installation_by_ins_id, body),
      AxiosServices.post(endpoints.common.get_finan_dist_operator_installation_by_ins_id, body),
      AxiosServices.post(endpoints.common.get_finan_dist_operator_installation_pars_ope_type_by_ins_id, body),
      AxiosServices.post(endpoints.common.get_installations_finan_pars_ope_type_by_ins_id, body),
      AxiosServices.post(endpoints.common.get_installations_last_ids, body)
    ]);
    return {
      externalProvidersApiMethods: externalProvidersApiMethods.data,
      externalProvidersIns: externalProvidersIns.data,
      dbpicInstallation: dbpicInstallation.data,
      integraInstallation: integraInstallation.data,
      finanDistOperatorInstallation: finanDistOperatorInstallation.data,
      finanDistOperatorParsOpeType: finanDistOperatorParsOpeType.data,
      installationsFinanParsOpeType: installationsFinanParsOpeType.data,
      installationsLastIds: installationsLastIds.data
    };
  }

}
const commonService = new CommonService();
export default commonService;
